import { AppDisplay } from '@ui/applications';
import dayjs from 'dayjs';
import dayjsduration from 'dayjs/plugin/duration';
import { getTimeRecordDate } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import { Button, Space } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC, DATA_SECURITY_DASHBOARD, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { IncidentEventTypeTag } from './IncidentEventTypeTag';
dayjs.extend(dayjsduration);
export const appDisplayColumn = {
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (_, { applicationId, applicationLabel, applicationName }) => React.createElement(AppDisplay, { appId: applicationId, appLabel: applicationLabel, appName: applicationName }),
    title: COPY_SPECIFIC.APPLICATION,
    width: 170
};
export const eventTypeColumn = {
    align: 'center',
    dataIndex: 'eventType',
    key: 'eventType',
    render: (eventType) => React.createElement(IncidentEventTypeTag, { eventType: eventType }),
    title: DATA_SECURITY_DASHBOARD.EVENT_TYPE,
    width: 80
};
export const startColumn = {
    align: 'right',
    dataIndex: 'eventStart',
    key: 'eventStart',
    render: (eventStart) => React.createElement(SonarText, null, getTimeRecordDate(eventStart)),
    title: COPY_GENERIC.START,
    width: 120
};
export const endColumn = {
    align: 'right',
    dataIndex: 'eventEnd',
    key: 'eventEnd',
    render: (eventEnd) => (eventEnd ? React.createElement(SonarText, null, getTimeRecordDate(eventEnd)) : null),
    title: COPY_GENERIC.END,
    width: 120
};
export const durationColumn = {
    align: 'right',
    key: 'duration',
    render: (_, { eventStart, eventEnd }) => {
        const start = dayjs(eventStart);
        const end = dayjs(eventEnd !== null && eventEnd !== void 0 ? eventEnd : undefined);
        const diff = end.diff(start);
        return (React.createElement(SonarText, null, dayjs.duration(diff).format('D [Day] H [Hrs] m [min]')
            .replace(/\b0 Day\b/u, '')
            .replace(/\b0 Hrs\b/u, '')
            .replace(/\b0 min\b/u, '')));
    },
    title: COPY_GENERIC.DURATION,
    width: 120
};
export const actionColumn = (navigate, appSelected) => ({
    dataIndex: 'applicationId',
    key: 'actions',
    render: (applicationId) => React.createElement(Space, { size: 8 },
        React.createElement(When, { condition: !appSelected },
            React.createElement(Button, { onClick: () => navigate(`${FULL_ROUTES.DATA_SECURITY}/${applicationId}`), type: 'primary' }, COPY_SPECIFIC.REVIEW))),
    title: COPY_SPECIFIC.ACTION,
    width: appSelected ? 0 : 120
});
export function getColumns(appSelected, navigate) {
    return [
        appDisplayColumn,
        eventTypeColumn,
        startColumn,
        endColumn,
        durationColumn,
        actionColumn(navigate, appSelected)
    ];
}
